
  import {Component, Ref, Vue, Watch} from "vue-property-decorator";
  import {CardDto, IncomeSupplementCategory, IncomeSupplementCreateOrUpdateDto} from "@/api/appService";
  import OrganizationUnitQuerySelect from "@/components/OrganizationUnitQuerySelect/index.vue";
  import SelectStore from "@/views/selectStore.vue";
  import {SelectListItem} from "@/core/common-type-definitions";
  import api from '@/api/index';
  import {ElForm} from "element-ui/types/form";
  import OrganizationUnitSelect from "@/components/OrganizationUnitSelect/index.vue";

  @Component({name:'EditIncomeSupplement',
    components: {OrganizationUnitSelect, SelectStore, OrganizationUnitQuerySelect}
  })
  export default class EditIncomeSupplement extends Vue{
    @Ref() readonly dataForm!: ElForm;

    public dataId:number  = 0;
    show=false;

    yearMonth = new Date();


    cardList:CardDto[] = [];

    defaultData:IncomeSupplementCreateOrUpdateDto = {
      cardId:undefined,
      category:undefined,
      displayName:'',
      month:1,
      year:(new Date()).getFullYear(),
      organizationUnitId:undefined,
      value:0
    }

    formData = {
      yearMonth:new Date()
    } as IncomeSupplementCreateOrUpdateDto;

    created(){
      this.formData = {...this.defaultData};
    }

    get title(){
      return this.dataId?"编辑":'新增'
    }

    get isCardCategory(){
      return this.formData.category === IncomeSupplementCategory.Card;
    }

    get allCategories() :SelectListItem<IncomeSupplementCategory>[] {
      return [
        {
          label:'活动收入',
          value:IncomeSupplementCategory.Activity
        },
        {
          label:'会员卡',
          value:IncomeSupplementCategory.Card
        },
      ]
    }

    @Watch('yearMonth')
    onYearDateChange(newValue:Date){
      this.formData.year = newValue.getFullYear();
      this.formData.month = newValue.getMonth() +1;
    }

    @Watch('formData.category')
    async onCategoryChange(category:IncomeSupplementCategory){
      if(category === IncomeSupplementCategory.Activity){
        this.formData.cardId = undefined;
      } else {
        await api.card.getAll({maxResultCount:65535,organizationUnitId:this.formData.organizationUnitId}).then(res=>{
          this.cardList = res.items!;
        });
      }
    }

    @Watch('show')
    onShowChange(value:boolean){

      if(value){
        if(this.dataId){
          api.incomeSupplement.get({id:this.dataId}).then(res=>{
            this.formData = {...res};
            this.yearMonth = new Date(this.formData.year!,this.formData.month!-1,1);
          });
        } else {
          this.formData = {...this.defaultData};
        }
      } else {
        this.formData = {...this.defaultData};
        this.cardList = [];
        this.$nextTick(() => {
          this.dataForm.clearValidate();
        });
      }

    }

    cancel() {
      this.show = false;
    }

    async save() {
      this.dataForm.validate(async (valid: boolean) => {
        if (valid) {
          if (this.formData!.id) {
            await api.incomeSupplement.update({ body: this.formData });
          } else {
            await api.incomeSupplement.create({ body: this.formData });
          }
          this.show = false;
          this.$message.success("更新成功");
        }
      });
    }

  }
